import {
  Table as TableMantine,
  TableProps,
  useMantineTheme,
} from "@mantine/core";

interface IProps extends TableProps {
  rows: React.ReactNode;
  cols: React.ReactNode;
}

const Table = ({ cols, rows, ...props }: IProps) => {
  const theme = useMantineTheme();
  return (
    <TableMantine
      {...props}
      horizontalSpacing="md"
      highlightOnHover
      sx={{
        background: theme.colors.basic[2],
        fontWeight: 500,
        th: {
          textAlign: "center",
          verticalAlign: "middle",
        },
        button: {
          color: theme.colors.basic[5],
          fontSize: "0.875rem",
        },
        tbody: {
          tr: {
            border: "1px solid",
            borderColor: theme.colors.basic[2],
            background: theme.colors.basic[0],
          },
          td: {
            lineHeight: "23px",
            color: theme.colors.basic[5],
            textAlign: "center",
            verticalAlign: "middle",
          },
        },
      }}
    >
      <thead>{cols}</thead>
      <tbody>{rows}</tbody>
    </TableMantine>
  );
};

export default Table;
